import { usePublishedContext } from '@/components/views/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/components/views/published/usePublishedSnapshotQuery';
import { useGetSchedulesByItemIds } from '@/lib/queries/work-integrations/useGetSchedules';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useSchedulesQueryWithPublished = (itemId: number, enabled = true) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schedulesQuery = useGetSchedulesByItemIds([itemId], undefined, !isPublished && enabled);

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: workIntegrationsQueryKeys.scheduleByItemId(itemId),
    getSnapshot: () => {
      if (!publishedContext) return undefined;
      const schedule = publishedContext.getItemPanelData(itemId)?.schedule;
      return schedule ? { [itemId]: { itemId, ...schedule } } : {};
    },
  });

  return isPublished ? publishedQuery : schedulesQuery;
};
